// src/pages/Service.jsx
import Layout from "../layouts/Layout";

import Breadcrumb from "../components/Breadcrumb";
import ServiceSection from "../components/Service/ServiceSection";
import TestimonialSection from "../components/About/TestimonialSection";
import BrandSection from "../components/BrandSection";

const Service = () => (
  <Layout>
    <Breadcrumb
      title="Dịch vụ"
      parent={{ name: "Trang chủ", path: "/" }}
    />
    <ServiceSection />
    <BrandSection />
    <TestimonialSection />
  </Layout>
);

export default Service;
